import { IPages } from "@/types";
import { useEffect, useState } from "react";
function getCookie(name: string) {
    const value = `; ${document.cookie}`;
    const parts: any = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
}
const useWebSocketImpersonate = ({
    impersonate,
    user,
    page,
}: {
    impersonate?: boolean;
    user: { id: string };
    page?: IPages;
}) => {
    const [ws, setWs] = useState<WebSocket | null>(null);
    useEffect(() => {
        if (impersonate) {
            let webSocket: WebSocket | null = null;
            const connectWebSocket = () => {
                webSocket = new WebSocket(
                    process.env.NEXT_PUBLIC_WS_SERVER + "/ws/impersonate"
                    // "ws://localhost:4000/ws/impersonate"
                );
                webSocket.onopen = () => {
                    webSocket?.send(
                        JSON.stringify({
                            type: "connect",
                            account_id: user.id,
                            page: page?.id || "home",
                            token: getCookie("sbat") || null,
                        })
                    );
                    setWs(webSocket);
                };
                webSocket.onclose = () => {
                    setWs(null);
                };
                webSocket.onerror = (error) => {
                    console.error("WebSocket error:", error);
                };
            };
            connectWebSocket();
            // Clean up WebSocket connection when the component unmounts or dependencies change
            return () => {
                if (webSocket) {
                    webSocket.close();
                }
            };
        }
    }, []);
    return { ws };
};

export { useWebSocketImpersonate };
